import ExternalLink from '../ExternalLink/ExternalLink';
import { YahooIcon } from './YahooIcon';
import { getYahooWrapperLink } from './getYahooWrapperLink';
import styles from './AccountItemIcon.module.scss';

export const YahooIconWrapper = ({ hasOuterLink, id }) => {
    if (hasOuterLink) {
        return <YahooIcon />;
    }

    return (
        <ExternalLink
            href={getYahooWrapperLink(id)}
            className={styles['icon-link']}
            onClick={e => {
                e.stopPropagation();
            }}
        >
            <YahooIcon />
        </ExternalLink>
    );
};
